import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectPaymentMethodPlaceholder: {
    id: '8DqB6t',
    defaultMessage: 'Select a payment method',
    description: 'Placeholder text for the payment method selection dropdown',
  },
  noPaymentMethodsAvailable: {
    id: 'pwbUm9',
    defaultMessage: 'No payment methods available',
    description: 'Message shown when no payment methods are available to select',
  },
});
